import { Component, Vue } from 'vue-property-decorator'

@Component
export default class EditorMixins extends Vue {

  mediaLibraryDialog = false

  titleToolbar = [
    [ { 'header': [ 1, 2, 3, 4, 5, 6, false ] } ],
    [ 'bold', 'italic', 'underline', 'strike' ],
    [ { 'color': [] }, { 'background': [] } ],
    [ 'link', 'clean' ]
  ]

  descEditorOptions = {
    modules: {
      toolbar: {
        container: [
          [ { 'header': [ 1, 2, 3, 4, 5, 6, false ] } ],
          [ 'bold', 'italic', 'underline', 'strike' ],
          [ { 'color': [] }, { 'background': [] } ],
          [ 
            // 'image', 
            'link', 
            'clean' 
          ],
          // [ 'video' ]
        ],
        handlers: {
          // image: () => {
          //   let range = this.$refs.editor.quill.getSelection();
          //   this.$prompt(null, 'Image Url', {
          //     confirmButtonText: 'Insert',
          //     cancelButtonText: 'Cancel',
          //   }).then(({ value }) => {
          //     if(value){
          //       this.$refs.editor.quill.insertEmbed(range.index, 'image', value, Quill.sources.USER);
          //     }
          //   })
          // },
          // video: () => {
          //   let range = this.$refs.editor.quill.getSelection();
          //   this.$prompt(null, 'Video Url', {
          //     confirmButtonText: 'Insert',
          //     cancelButtonText: 'Cancel',
          //   }).then(({ value }) => {
          //     if(value){
          //       this.$refs.editor.quill.insertEmbed(range.index, 'video', value, Quill.sources.USER);
          //     }
          //   })
          // }
        }
      }
    }
  }
}